import React from 'react';

/**
 * Unfiled topic pill for Connections default strip / All unfiled grid.
 */
const ConnectionsUnfiledTopicPill = ({ topic, onClick }) => {
  const tag = topic?.tag || topic?.tags;
  const tagColor = tag?.color;

  const handleClick = () => {
    onClick?.(topic);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      className="inline-flex items-center gap-2 shrink-0 max-w-[220px] px-3 py-2 rounded-full border border-neutral-200 bg-white text-left hover:bg-neutral-50 focus:outline-none focus:ring-2 focus:ring-cranberry-700"
      aria-label={`Open unfiled topic ${topic?.name || ''}`}
    >
      {tagColor && (
        <span
          className="w-2.5 h-2.5 rounded-full shrink-0"
          style={{ backgroundColor: tagColor }}
          aria-hidden="true"
        />
      )}
      <span className="text-sm font-medium text-neutral-800 truncate">
        {topic?.name}
      </span>
    </button>
  );
};

export default ConnectionsUnfiledTopicPill;
